// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__Vr5wR","hand":"Home_hand__-fxaQ","wave":"Home_wave__SmCpI"};